import { useState } from "react";
import { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import cursor from "src/constants/cursor";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { Text } from "src/swsh-native";
import usePillSizing from "src/swsh-native/Pill/hooks/usePillSizing";
import TouchableScale from "../TouchableScale";
import { InteractivePillButtonProps } from "./types";

const InteractivePillButton = ({
	colorVariant = "Default",
	disabled = false,
	onPress,
	sizeVariant = "md",
	testID,
	style,
	children,
	isSelected = false,
}: InteractivePillButtonProps) => {
	const { theme } = useStyle();
	const scaleSV = useSharedValue<number>(1);
	const [isHovering, setIsHovering] = useState(false);

	const { size, paddingHorizontal, borderRadius } = usePillSizing(sizeVariant);
	const animatedStyle = useAnimatedStyle(
		() => ({
			opacity: withTiming(disabled ? 0.5 : 1),
			transform: [{ scale: scaleSV.value }],
		}),
		[disabled, scaleSV],
	);

	return (
		<TouchableScale
			onPress={onPress}
			testID={testID}
			onMouseEnter={() => setIsHovering(true)}
			onMouseLeave={() => setIsHovering(false)}
			style={[
				{
					height: size,
					paddingHorizontal,
					cursor: disabled ? cursor.notAllowed : cursor.pointer,
					backgroundColor: isSelected
						? color.PillBackgroundAlt[theme]
						: isHovering && !disabled
							? color.PillBackgroundHover[theme]
							: color.PillBackground[theme],
					justifyContent: "center",
					alignItems: "center",
					// @ts-expect-error
					transition: "background-color 0.2s ease",
					borderRadius,
				},
				style,
			]}
			animatedStyle={animatedStyle}
		>
			<Text>{children}</Text>
		</TouchableScale>
	);
};
export default InteractivePillButton;
